(function($) {
  function newhomepageSlick(){
    $('.ri-txt-slide-slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      draggable: false,
      asNavFor: '.ri-img-slide-slick',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            dots: true
          }
        }
      ]
    });
    $('.ri-img-slide-slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      fade: true,
      lazyLoad: 'ondemand',
      asNavFor: '.ri-txt-slide-slick',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            dots: false
          }
        }
      ]
    });
  }

  function paddingSlideText(){
    var containerWidth = $('.header .container').width(),
        windoWidth = $(window).width(),
        leftPadding = windoWidth - containerWidth,
        tagetSection = $('.ris-text-content');
        tagetSection.each(function(){
          if($(this).hasClass("right-side")){
            $(this).css('padding-right', leftPadding/2);
          }else {
            $(this).css('padding-left', leftPadding/2);
          }
        });
        
    
  }
  $(window).resize(paddingSlideText);


  function benefitsListSlick(){
    if($(window).width() < 768 ){
      $('.benefits-list-slick').each(function(){
        $('.benefits-list-slick').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<div class="benefits-slick-arrow ben-slick-prev"><svg class="icon icon-arrow-left" aria-hidden="true"><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="benefits-slick-arrow ben-slick-next"><svg class="icon icon-arrow-right" aria-hidden="true"><use xlink:href="#icon-arrow-right"></use></svg></div>',
          dots: true,
        });
        
      });
      $('.prod-features.grid').each(function(){
        $(this).slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        });
      });
      $('.section-testimonials .testimonials.grid').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
    }else{
      $('.benefits-list-slick').each(function(){
        $('.benefits-list-slick').slick('unslick');
      });
    }
  }
  $(window).resize(benefitsListSlick);


  var totalElementHeight = 0;
  var elementVdistance = 0;
  var contentWrapHeight = 0;
  function faqNavSticky(){
    totalElementHeight = $(".faq-page-nav").outerHeight(true) - 46;
    elementVdistance = $(".faq-page-nav").offset().top - totalElementHeight;
    contentWrapHeight = $(".faq-content-wrapper").outerHeight(true) - (totalElementHeight * 2);
  }
  $(document).ready(function() {
    if($('.productpage-capabilities-section').length > 0 ){
      $('#shopify-section-prod-feature-capabilities').prependTo('.productpage-capabilities-section');
    }
    newhomepageSlick();
    paddingSlideText();
    benefitsListSlick();
    if ($(".faq-page-nav").length > 0 ){
      faqNavSticky();
			$(window).resize(function() {
				totalElementHeight = $(".faq-page-nav").outerHeight(true) - 46;
				elementVdistance = $(".faq-page-nav").offset().top - totalElementHeight;
				contentWrapHeight = $(".faq-content-wrapper").outerHeight(true) - (totalElementHeight * 2);
			});
			$(document).on("scroll", function(){
				if($(document).scrollTop() > elementVdistance && $(window).width() > 560 ){
						$(".faq-page-nav").addClass("sticky");
						if($(document).scrollTop() > contentWrapHeight + elementVdistance){
							$(".faq-page-nav").addClass("stop");
							$(".faq-page-nav").css("top", contentWrapHeight + elementVdistance + totalElementHeight);
						}else{
							$(".faq-page-nav").removeClass("stop");
							$(".faq-page-nav").css("top", '100px');
						}
				}
				else
				{
					$(".faq-page-nav").removeClass("sticky");
				}
			});
    }
    
  });
})(jQuery);

/*  REORDER FUNCTIONALITY */
this.reorder = new function(){
  var self = this;

  this.pushQueue = function(i, data, el){
    
    //LOW STOCK -- add as many as possible if stock is below requested ammount
    if(data[i].check_inventory){
      data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
    }
    
    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      data: {
        quantity: data[i].quantity,
        id: data[i].id
      },
      complete: function(res){
        if(i >= data.length - 1){
          //products from queue are now added to the cart -> stop loading signal and go to cart
          el.removeClass('loading');
          window.location.href = '/cart';
          return;
        }else{
          // Calls are async as required by Shopify Docs
       	  self.pushQueue(i+1, data, el);
        }
      }
    });
  }

  this.listen = function(){
    var el = $(this);
    var ids = el.attr('data-variant-ids').split(',');
    var quantities = el.attr('data-variant-quantities').split(',');
    var inventories = el.attr('data-variant-inventories').split(',');
    var inventory_policies = el.attr('data-variant-inventory-policies').split(',');
    var inventory_trackers = el.attr('data-variant-inventory-trackers').split(',');
    ids.splice(-1, 1);
    quantities.splice(-1, 1);
    inventories.splice(-1, 1);
    inventory_policies.splice(-1, 1);
    inventory_trackers.splice(-1, 1);
    
    var data = [];
    for(var i=0; i<ids.length; i++){
      data.push({
        id: ids[i],
        quantity: quantities[i],
        inventory: inventories[i],
        check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != "")
      });
    }
    el.addClass('loading');
    self.pushQueue(0, data, el);
  }
  
  this.init = function(){
    $('.reorder-btn').on('click', self.listen);
  }
}
$(reorder.init);



class CartWatcher {

  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
          throw new Error('Failed to fetch cart data');
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return null; 
    }
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  cartChangeQueue = [];
  isProcessingQueue = false;

  async processQueue() {
    if (this.isProcessingQueue || !this.cartChangeQueue.length) return;

    this.isProcessingQueue = true;
    while (this.cartChangeQueue.length) {
      const task = this.cartChangeQueue.shift();
      await task();
    }
    this.isProcessingQueue = false;
  }

  async emitCartChanges() {
    this.cartChangeQueue.push(async () => {
      const newCart = await this.fetchCart();
      if (!newCart) return;
      const oldCart = this.storedCart();
      const changes = this.findCartChanges(oldCart, newCart);
      changes.cart = newCart;

      const event = new CustomEvent("cart_changed", { detail: changes });
      window.dispatchEvent(event);

      this.storeCart(newCart);
    });

    this.processQueue();
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let added = onlyInLeft(newCart.items, oldCart.items);
    let removed = onlyInLeft(oldCart.items, newCart.items);

    const changed = oldCart.items
        .map(oi => {
            const ni = newCart.items.find(i => i.key == oi.key);
            if (!ni || ni.quantity === oi.quantity) return null;
            let quantityChange = ni.quantity - oi.quantity;
            return {
                ...ni,
                quantity: Math.abs(quantityChange)
            };
        })
        .filter(Boolean);

    return {
        added: [...added, ...changed.filter(item => item.quantity > 0)],
        removed: [...removed, ...changed.filter(item => item.quantity < 0)]
    };
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}

var giftWithPurchase = {

  freeGiftMappings: [
      {
          categoryName: 'small',
          triggerProductIds: [8150015410291, 41634951332024, 41635351003320],
          freeGiftId: 17137546395763
      },
      {
          categoryName: 'medium',
          triggerProductIds: [8150015377523, 41635351724216, 41635353100472],
          freeGiftId: 17137622745203
      },
      {
          categoryName: 'large',
          triggerProductIds: [42388976992440, 41635359162552],
          freeGiftId: 17137638670451
      }
  ],

  isScriptUpdatingCart: false,

  init: function() {
      const myCartWatcher = new CartWatcher();
      myCartWatcher.init();

      window.addEventListener("cart_changed", e => {
        // Exit early if the change is initiated by the script
        if (this.isScriptUpdatingCart) return;

        //console.log("cart_changed", e.detail);

        const cartChanges = e.detail;

        const freeGiftIds = this.freeGiftMappings.map(mapping => mapping.freeGiftId);
        const isGiftInAddedItems = cartChanges.added.some(item => freeGiftIds.includes(item.id));
        const isGiftInRemovedItems = cartChanges.removed.some(item => freeGiftIds.includes(item.id));

        if (!isGiftInAddedItems && !isGiftInRemovedItems) {
            const giftsToAdd = this.getGiftsForAddedItems(cartChanges.added);
            
            for(let giftObj of giftsToAdd) {
                if (!this.wasItemRecentlyRemoved(giftObj.giftId)) {
                    this.addFreeGiftToCart(giftObj.giftId, giftObj.quantity);
                }
            }
        }
      });
  },

  wasItemRecentlyRemoved: function(itemId) {
    if (this.lastRemovedItems && this.lastRemovedItems.includes(itemId)) {

        this.lastRemovedItems = null;
        return true;
    }
    return false;
  },

  getGiftForAddedItems: function(addedItems) {
    if (!addedItems.length) return null;
    for (let mapping of this.freeGiftMappings) {
        for (let item of addedItems) {
            if (mapping.triggerProductIds.includes(item.id)) {
                return mapping.freeGiftId;
            }
        }
    }
    return null;
  },

  getGiftsForAddedItems: function(addedItems) {
    let giftsWithQuantity = [];
    if (!addedItems.length) return giftsWithQuantity;

    for (let mapping of this.freeGiftMappings) {
        for (let item of addedItems) {
            if (mapping.triggerProductIds.includes(item.id)) {
                giftsWithQuantity.push({
                    giftId: mapping.freeGiftId,
                    quantity: item.quantity // Assuming item has a 'quantity' property
                });
            }
        }
    }
    return giftsWithQuantity;
  },


  isGiftInCart: function(giftId, cartItems) {
      return cartItems.some(item => item.id === giftId);
  },

  addFreeGiftToCart: function(giftId, quantity = 1) {
    this.isScriptUpdatingCart = true;
    const cartAddUrl = `/cart/add.js?quantity=${quantity}&id=${giftId}`;
    fetch(cartAddUrl, {
      method: 'POST'
    })
    .then(response => response.json())
    .then(data => {
      this.isScriptUpdatingCart = false;
        if (data.status === 422) {
            console.error('Error adding free gift to cart:', data.message);
        } else {
            console.log('Free gift added to cart:', data);
            
            var modifiedTitle = data.product_title.replace(" (Cover Only)", "");
            $('.success_text_popup').append('<br /><br />Plus a FREE "' + modifiedTitle + '"!</h3>');
            $('.success_text_popup').attr('style', 'padding: 50px 0 20px 0;');
    
            fetch('/cart.js', {
                method: 'GET'
            })
            .then(response => response.json())
            .then(cart => {
                if (cart.status === 422) {
                    console.error('Error getting the cart:', cart.message);
                } else {
                    $(document).trigger('theme:cart:updated', [cart, true, true]);
                }
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error.message);
            });
        }
    })
      .catch(error => {
        this.isScriptUpdatingCart = false;
        console.error('Error adding free gift:', error);
      });  
    }
};

// $(document).ready(function() {
//   giftWithPurchase.init();
// });

class HeaderCartCountSync {
  constructor() {
    this.isBoundToRebuy = false;
    this.updateFromServer = this.updateFromServer.bind(this);
  }

  init() {
    this.updateFromStoredCart();
    this.updateFromServer();
    this.bindThemeEvents();
    this.bindRebuyEvents();
  }

  bindThemeEvents() {
    window.addEventListener("cart_changed", (event) => {
      const cart = event && event.detail ? event.detail.cart : null;
      if (cart) {
        this.updateCount(cart.item_count);
      } else {
        this.updateFromServer();
      }
    });

    $(document).on("theme:cart:updated", (event, cart) => {
      if (cart && typeof cart.item_count !== "undefined") {
        this.updateCount(cart.item_count);
      } else {
        this.updateFromServer();
      }
    });
  }

  bindRebuyEvents() {
    const rebuyEventNames = [
      "rebuy:cart.change",
      "rebuy:smartcart.ready",
      "rebuy:smartcart.show",
      "rebuy:smartcart.hide",
      "rebuy:smartcart.refresh"
    ];

    rebuyEventNames.forEach((eventName) => {
      document.addEventListener(eventName, this.updateFromServer);
    });

    this.tryBindRebuySmartCartApi();
    setTimeout(() => this.tryBindRebuySmartCartApi(), 1000);
    setTimeout(() => this.tryBindRebuySmartCartApi(), 3000);
  }

  tryBindRebuySmartCartApi() {
    if (this.isBoundToRebuy) return;
    if (!window.Rebuy || !window.Rebuy.SmartCart || typeof window.Rebuy.SmartCart.on !== "function") return;

    this.isBoundToRebuy = true;

    window.Rebuy.SmartCart.on("cart.change", (cart) => {
      if (cart && typeof cart.item_count !== "undefined") {
        this.updateCount(cart.item_count);
      } else {
        this.updateFromServer();
      }
    });

    window.Rebuy.SmartCart.on("cart.ready", (cart) => {
      if (cart && typeof cart.item_count !== "undefined") {
        this.updateCount(cart.item_count);
      } else {
        this.updateFromServer();
      }
    });
  }

  updateFromStoredCart() {
    const storedCart = this.getStoredCart();
    if (storedCart && typeof storedCart.item_count !== "undefined") {
      this.updateCount(storedCart.item_count);
    }
  }

  async updateFromServer() {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) return;
      const cart = await response.json();
      this.updateCount(cart.item_count || 0);
    } catch (error) {
      console.error("Error updating header cart count:", error);
    }
  }

  getStoredCart() {
    try {
      return JSON.parse(localStorage.getItem("cart"));
    } catch (error) {
      return null;
    }
  }

  updateCount(count) {
    const parsedCount = Number.isFinite(Number(count)) ? Number(count) : 0;
    document.querySelectorAll(".header__cart-count").forEach((el) => {
      el.textContent = parsedCount;
    });
  }
}

$(document).ready(function() {
  const headerCartCountSync = new HeaderCartCountSync();
  headerCartCountSync.init();
});



